import {BaseService} from "./base.service";

class CatalogLaboratoryService extends BaseService {

    constructor() {
        super('api/catalog-laboratory')
    }

}

export const catalogLaboratoryService = new CatalogLaboratoryService();
